export function useMedia(_: string): boolean {
  return false;
}
